export const DEMO_SEGMENT_CONFIG = [
  {
    name: 'Signed Up',
    type: 'dynamic',
    archived: false,
    conditions: {
      and: [
        {
          event: {
            filters: {},
            id: 1,
            name: 'created_account',
            type: 'event',
            ui_type: '',
          },
          inverse: false,
          times: 1,
          within: 0,
        },
      ],
    },
  },
  {
    name: 'Logged In',
    type: 'dynamic',
    archived: false,
    conditions: {
      and: [
        {
          event: {
            filters: {},
            id: 2,
            name: 'logged_in',
            type: 'event',
            ui_type: '',
          },
          inverse: false,
          times: 1,
          within: 604800,
        },
      ],
    },
  },
  {
    name: 'Opted-in for Push',
    type: 'dynamic',
    archived: false,
    conditions: {
      and: [
        {
          event: {
            filters: {
              and: [
                {
                  field: 'to',
                  inverse: false,
                  operator: 'eq',
                  value: 'true',
                },
                {
                  field: 'from',
                  inverse: true,
                  operator: 'eq',
                  value: 'true',
                },
              ],
            },
            id: 3,
            name: 'push_allowed',
            type: 'attribute_change',
          },
          inverse: false,
          times: 1,
          within: 0,
        },
      ],
    },
  },
  {
    name: 'Opted-in for Email',
    type: 'dynamic',
    archived: false,
    conditions: {
      and: [
        {
          event: {
            filters: {
              and: [
                {
                  field: 'to',
                  inverse: false,
                  operator: 'eq',
                  value: 'true',
                },
                {
                  field: 'from',
                  inverse: true,
                  operator: 'eq',
                  value: 'true',
                },
              ],
            },
            id: 4,
            name: 'email_allowed',
            type: 'attribute_change',
          },
          inverse: false,
          times: 1,
          within: 0,
        },
      ],
    },
  },
  {
    name: 'Opted-in for SMS',
    type: 'dynamic',
    archived: false,
    conditions: {
      and: [
        {
          event: {
            filters: {
              and: [
                {
                  field: 'to',
                  inverse: false,
                  operator: 'eq',
                  value: 'true',
                },
                {
                  field: 'from',
                  inverse: true,
                  operator: 'eq',
                  value: 'true',
                },
              ],
            },
            id: 5,
            name: 'sms_allowed',
            type: 'attribute_change',
          },
          inverse: false,
          times: 1,
          within: 0,
        },
      ],
    },
  },
];
